import React from "react";
import Report from "../../../components/user/report/reportForm";
import Layout from "../../../components/layouts/verticalLayout";
import { useParams } from "react-router-dom";

const ReportFormPage = () => {
  let { uuid } = useParams();
  return <Layout body={<Report uuid={uuid} />} />;
};

ReportFormPage.propTypes = {};

export default ReportFormPage;
